module.exports = __webpack_public_path__ + "static/media/paleta.c81848f6.jpeg";